
import React from 'react'
import { translate, getPrice } from '../../../../utils/translator';

type Props = {
    id?: string,
    languageID: string,
    onClick: () => void,
    className?: string,
    desktop?: boolean
    disabled?: boolean,
    totalPrice?: number,
    numOfItems?: number,
    locale?: string
}

const SubmitButton: React.FC<Props> = ({id, onClick, desktop, disabled,languageID, className, totalPrice, numOfItems, locale = 'de-DE'}) => {

  const styleBasedOnDisabled = () => {
    if (disabled) {
      return `cursor-not-allowed rounded-md bg-primary-button-gradient-hover opacity-60 p-5 text-white text-center font-bold ${className}`
    }
    return `cursor-pointer rounded-md bg-primary-button-gradient p-5 text-center font-bold hover:opacity-90 transition-opacity ${className}`
  }

  return (
    <div
      id={id ?? (desktop ? "desktop-choose-treatment-submit-button" : "mobile-choose-treatment-submit-button")}
      onClick={disabled ? () => {} : onClick}
      className={`flex flex-row ${styleBasedOnDisabled()}`}
    >
      <div className="flex items-center justify-center bg-white text-[#269C6E] rounded-full w-6 h-6 mr-2">
        {numOfItems}
      </div>
      <p id="submit-button-text" className="m-0 flex-1 flex justify-between text-white">
        <span>{translate(languageID, 'choose_treatment', 'default/view_order_button') || 'Bestellung ansehen'}</span>
        <span>{getPrice(totalPrice || 0, locale)}</span>
      </p>
    </div>
  )
}

export default SubmitButton
